<template>
<div class="text-xs-center" style="position: relative">
  <v-avatar
      v-if="url && !base64Data"
      :tile="tile"
      slot="activator"
      @click="getPhoto"
      :size="size">
      <img
        :src="url"
        alt="Avatar"
        height="100px"
        >
  </v-avatar>
  <v-icon  v-if="!base64Data && !url" @click="getPhoto" color="primary" :size="sizeIcon">{{ icon }}</v-icon>
  <v-avatar
    :tile="tile"
    v-if="base64Data"
    slot="activator"
    @click="getPhoto"
    :size="size">
    <img
      :src="base64Data"
      alt="Avatar"
      >
  </v-avatar>
  <div v-if="updateIcon && (url || base64Data)" @click="getPhoto" class="card-img-overlay" :style="{ width:  size + 'px'}"><button id="pick-avatar" class="btn btn-primary btn-sm">{{ $t('account.update_photo') }}</button></div>
</div>
</template>

<script>
import { Plugins, CameraResultType } from '@capacitor/core'
const { Camera, Keyboard } = Plugins
export default {
  name: 'AvatarNatif',

  computed: {
    base64Data: function () {
      return this.$store.getters['Device/getBase64']
    }
  },

  props: {
    'icon': {
      default: 'account_circle',
      type: String
    },
    'url': {
      default: '',
      type: String
    },
    'tile': {
      default: false,
      type: Boolean
    },
    'updateIcon': {
      default: false,
      type: Boolean
    },
    'size': {
      default: '150px',
      type: String
    },
    'sizeIcon': {
      default: '80',
      type: String
    }
  },

  methods: {
    async getPhoto () {
      this.photo = await Camera.getPhoto({
        quality: 80,
        allowEditing: false,
        correctOrientation: true,
        presentationStyle: 'popover',
        saveToGallery: true,
        resultType: CameraResultType.DataUrl,
        width: 1600
      })
      this.$store.dispatch('Device/saveBase64', this.photo.dataUrl)
      Keyboard.hide()
    }
  }

}
</script>

<style>
  .card-img-overlay {
    background: rgba(0,0,0,.54);
    transition: all 0.5s;
  }
  .card-img-overlay {
      position: absolute;
      border-radius:0 0 200px 200px;
      max-width:480px;
      color: #fff;
      top: 50%;
      margin-left: auto;
      margin-right: auto;
      line-height: 18px;
      right: 0;
      bottom: 0;
      left: 0;
  }
</style>
